var map = {
	"./028989_denim_l.webp": 9331,
	"./028990_denim_back_l.webp": 3115,
	"./2016-06-09.jpg": 3494,
	"./24-hour-call-service.png": 2684,
	"./24-hour-clock.png": 7082,
	"./3302738.webp": 2894,
	"./5b61a57b25252.jpg": 5357,
	"./5c73c739a75d1215705264.jpg": 842,
	"./Profile.png": 8825,
	"./_SFn-FilterReferences-PublicationYear-RangeEntered.png": 8214,
	"./account.png": 5183,
	"./add (1).png": 6901,
	"./add-to-cart.png": 3922,
	"./add.png": 4567,
	"./as-jpeg-500x500.jpeg": 5523,
	"./baby-gf1e0a29f3_640-removebg-preview.png": 4251,
	"./box (1).png": 2627,
	"./box.png": 7765,
	"./calendar.png": 238,
	"./cancel.png": 4338,
	"./cart.png": 8838,
	"./category.png": 8632,
	"./checked.png": 1721,
	"./chip.png": 9278,
	"./clothes.png": 978,
	"./clothing.png": 1308,
	"./complaint.png": 4941,
	"./customer.png": 6104,
	"./customerservice.png": 3259,
	"./cvv.png": 5193,
	"./dashboard.png": 6282,
	"./deal-page-467x316-levis1.jpg": 6125,
	"./discount (1).png": 3655,
	"./discount.png": 5417,
	"./ecommerce (1).png": 8676,
	"./ecommerce (2).png": 1777,
	"./ecommerce.png": 3026,
	"./email.png": 7558,
	"./feedback.png": 1989,
	"./fire.png": 2928,
	"./flat-design-people-4682770__340.webp": 4154,
	"./girl.png": 6274,
	"./hand (1).png": 3161,
	"./home (3).png": 1869,
	"./images (1).jpg": 5072,
	"./images.jpg": 9030,
	"./income.png": 4001,
	"./jdie_product_list.webp": 9349,
	"./jpg.jpg": 8099,
	"./levi.png": 4510,
	"./levis-nextgen-stores-interview-01-1352x845.jpg": 2515,
	"./lock (1).png": 3667,
	"./login-arrow.png": 7473,
	"./logout-arrow.png": 1862,
	"./maestro.png": 3937,
	"./man.png": 8294,
	"./mc_8899941_2020-05-12-12-31-28-000929.jpg": 5203,
	"./model-gc65100ef7_640-removebg-preview.png": 9674,
	"./new images/add (1).png": 2978,
	"./new images/box (1).png": 7288,
	"./new images/category.png": 1397,
	"./new images/customer.png": 7941,
	"./new images/dashboard.png": 3629,
	"./new images/discount.png": 1004,
	"./new images/orders.png": 5114,
	"./new images/package.png": 9501,
	"./new images/price-tag.png": 1861,
	"./new images/product (1).png": 90,
	"./new images/product (2).png": 6059,
	"./new images/supermarket.png": 9780,
	"./new images/swirly-scribbled-arrow.png": 120,
	"./new-product.png": 9026,
	"./online-shopping-for-women-2254226__340.webp": 8590,
	"./online-shopping-for-women-gcf940d030_1280-removebg-preview.png": 7743,
	"./orders.png": 1967,
	"./package.png": 9954,
	"./pay (1).png": 4186,
	"./pin-number.png": 7277,
	"./premium (1).png": 6983,
	"./premium.png": 8841,
	"./price-tag.png": 2394,
	"./product (1).png": 7565,
	"./product (2).png": 8000,
	"./product.png": 5071,
	"./rating (1).png": 8961,
	"./rating.png": 3843,
	"./recieved.png": 2373,
	"./return-delivery-box.png": 9257,
	"./right.png": 548,
	"./sales.png": 9150,
	"./search.png": 4664,
	"./shield.png": 4643,
	"./shopping-bags.png": 1342,
	"./shopping-girl (1).png": 3491,
	"./shopping-girl.png": 7653,
	"./shopping-store.png": 4512,
	"./shopping.png": 8396,
	"./smartphone.png": 2893,
	"./supermarket.png": 7295,
	"./swirly-scribbled-arrow.png": 4269,
	"./truck.png": 3963,
	"./urgent-shopping.png": 2366,
	"./user (1).png": 2019,
	"./user (2).png": 5554,
	"./user.png": 7477,
	"./van-heusen-shirt-500x500.png": 932,
	"./waiting.png": 4795,
	"./woman (1).png": 182,
	"./woman-gd23c17d79_640-removebg-preview.png": 5782,
	"./woman.png": 3508,
	"./wrangler-store-vastrapur-ahmedabad-readymade-garment-retailers-3fslv3x.webp": 7325,
	"./x.png": 5246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7958;